export const inputBaseClass =
  'block w-full min-w-0 border bg-white px-4 text-[16px] text-ink placeholder:text-steel/70 transition-colors duration-150 ease-out hover:border-steel/60 focus:border-ink';

export function inputClass(hasError: boolean, extra = 'h-12'): string {
  return `${inputBaseClass} ${extra} ${hasError ? 'border-brand-deep' : 'border-line'}`;
}

export const buttonBaseClass =
  'group inline-flex h-12 min-h-[44px] items-center justify-center gap-2.5 whitespace-nowrap px-6 font-display text-[18px] font-semibold uppercase tracking-[0.06em] transition-colors duration-150 ease-out md:h-14 md:px-7';

export const buttonPrimaryClass = `${buttonBaseClass} bg-brand text-white hover:bg-brand-deep`;

export const buttonOutlineLightClass = `${buttonBaseClass} border border-ink/25 text-ink hover:border-ink hover:bg-ink/[0.03]`;
